"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

var _compositionsCleanTabs = require("@eig-builder/compositions-clean-tabs");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CompositionsModal = function CompositionsModal(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onBack = _ref.onBack,
      maxWidth = _ref.maxWidth,
      height = _ref.height,
      children = _ref.children,
      actions = _ref.actions,
      title = _ref.title,
      subtitle = _ref.subtitle,
      tabConfig = _ref.tabConfig,
      activeIndex = _ref.activeIndex,
      setActiveIndex = _ref.setActiveIndex,
      fullWidth = _ref.fullWidth,
      dataElementPrefix = _ref.dataElementPrefix,
      variant = _ref.variant,
      mobileRes = _ref.mobileRes,
      contentSpacing = _ref.contentSpacing,
      ModalProps = _ref.ModalProps,
      ContentProps = _ref.ContentProps;
  var fullScreen = (0, _useResponsiveQuery.useIsHandheld)();
  return _react.default.createElement(_moduleModal.default, _extends({
    open: open,
    onClose: onClose,
    maxWidth: maxWidth,
    variant: variant,
    fullScreen: fullScreen,
    fullWidth: fullWidth,
    height: height,
    dataElementPrefix: dataElementPrefix
  }, ModalProps), _react.default.createElement(_moduleModal.default.Header, null, onBack && _react.default.createElement(_moduleModal.default.Alignment, null, _react.default.createElement(_moduleModal.default.Header.Back, {
    onClick: onBack
  })), _react.default.createElement(_moduleModal.default.Alignment, {
    alignSelf: "center"
  }, _react.default.createElement(_moduleModal.default.Header.Title, {
    title: title,
    subtitle: subtitle
  })), _react.default.createElement(_moduleModal.default.Alignment, {
    rightAligned: true
  }, _react.default.createElement(_moduleModal.default.Header.Close, null))), _react.default.createElement(_moduleModal.default.Tabs, {
    mobileRes: mobileRes,
    value: activeIndex,
    onChange: function onChange(i) {
      return setActiveIndex(i);
    },
    dataElementLocation: _taggingHelper.DataElementLocations.POP_UP,
    tabs: tabConfig,
    dataElementPrefix: dataElementPrefix
  }), _react.default.createElement(_moduleModal.default.Content, _extends({
    contentSpacing: fullScreen ? 'small' : contentSpacing
  }, ContentProps), _react.default.createElement(_compositionsCleanTabs.AnimatedView, {
    activeIndex: activeIndex
  }, children)), actions && actions.length > 0 && _react.default.createElement(_moduleModal.default.Footer, {
    bordered: true
  }, _react.default.createElement(_moduleModal.default.Alignment, {
    rightAligned: true
  }, actions)));
};

CompositionsModal.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]).isRequired,
  actions: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),
  title: _propTypes.default.node.isRequired,
  variant: _propTypes.default.oneOf(['default', 'transparent', 'light']),
  contentSpacing: _propTypes.default.oneOf(['xs', 'small', 'medium', 'large']),
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  height: _propTypes.default.string,
  subtitle: _propTypes.default.node,
  onBack: _propTypes.default.func,
  dataElementPrefix: _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  mobileRes: _propTypes.default.number,
  // Tabs
  tabConfig: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
    dataElementLocation: _propTypes.default.string.isRequired,
    dataElementLabel: _propTypes.default.string.isRequired,
    dataElementId: _propTypes.default.string.isRequired
  })),
  activeIndex: _propTypes.default.number.isRequired,
  setActiveIndex: _propTypes.default.func.isRequired,
  ModalProps: _propTypes.default.object,
  ContentProps: _propTypes.default.object
};
CompositionsModal.defaultProps = {
  fullWidth: true,
  maxWidth: 'lg',
  variant: 'default',
  contentSpacing: 'large',
  ModalProps: {},
  ContentProps: {}
};
var _default = CompositionsModal;
exports.default = _default;